import { render, staticRenderFns } from "./CmgRefresh.vue?vue&type=template&id=218d3882&scoped=true&lang=pug&"
import script from "./cmg-refresh.ts?vue&type=script&lang=ts&"
export * from "./cmg-refresh.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRefresh.vue?vue&type=style&index=0&id=218d3882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d3882",
  null
  
)

export default component.exports